export default {
  name: 'FilePreviewComponent',
  props: {
    file: {
      type: Object,
      default: null
    },
    presigned_url: {
      type: String,
      default: ''
    },
    file_name: {
      type: String,
      default: ''
    }
  },
  emits: ['close'],
  data: () => ({
    loading: true,
    preview_url: '',
    file_type: '',
    file_extension: '',
    internal_file_name: '',
    office_embed_url: '',
    preview_error_message: ''
  }),
  mounted() {
    this.initialize_component();
  },
  methods: {
    initialize_component() {
      // Determine if we have a file object or direct URL
      if (this.file) {
        this.internal_file_name = this.file.name || this.file.file_name || '';
        this.preview_url = this.file.presigned_url || this.file.url || '';
      } else {
        this.internal_file_name = this.file_name;
        this.preview_url = this.presigned_url;
      }

      // Extract file extension and type
      this.extract_file_info();
      this.configure_preview_mode();

      // Simulate loading (remove in production)
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },

    extract_file_info() {
      if (!this.internal_file_name) {
        // Try to extract from URL as fallback
        const url_parts = this.preview_url.split('/');
        this.internal_file_name = url_parts[url_parts.length - 1].split('?')[0];
      }

      // Get file extension
      const name_parts = this.internal_file_name.split('.');
      this.file_extension = name_parts.length > 1
        ? name_parts[name_parts.length - 1].toLowerCase()
        : '';

      // Set file type (same as extension for simplicity)
      this.file_type = this.file_extension;

      // Fallback: many stored PDF answers use UUID keys without extension.
      if (!this.file_type && this.preview_url) {
        const lower_url = String(this.preview_url).toLowerCase();
        if (lower_url.includes('application/pdf') || lower_url.includes('.pdf')) {
          this.file_type = 'pdf';
        } else {
          this.file_type = 'pdf';
        }
      }

      if (this.file_type === 'pdf' && this.internal_file_name && !this.internal_file_name.includes('.')) {
        this.internal_file_name = `${this.internal_file_name}.pdf`;
      }
    },

    is_office_file_type() {
      return ['doc', 'docx', 'xls', 'xlsx', 'xlsm', 'xlsb', 'ppt', 'pptx'].includes(this.file_type);
    },

    can_use_office_embed() {
      if (!this.is_office_file_type() || !this.preview_url) return false;

      const url = String(this.preview_url).trim();
      if (!url || url.startsWith('blob:')) return false;

      try {
        const parsed = new URL(url, window.location.origin);
        return parsed.protocol === 'https:';
      } catch (error) {
        return false;
      }
    },

    configure_preview_mode() {
      this.office_embed_url = '';
      this.preview_error_message = '';

      if (!this.is_office_file_type()) return;

      if (this.can_use_office_embed()) {
        this.office_embed_url = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(this.preview_url)}`;
        return;
      }

      this.preview_error_message =
        'This Office file cannot be previewed in the browser from a local upload or a protected file link. Please download it to view it.';
    },

    close_file_preview_modal() {
      this.$emit('close');
    }
  }
};